module.exports = __webpack_public_path__ + "static/media/maduro.308030e4.mov";